// @flow

import _ from 'lodash';
import ko from 'knockout';

const { event: eventBindingHandlerBase } = ko.bindingHandlers;

const report = (...args: any) => {
	if (ko.options.bindingOptionsValidation === 'error') {
		console.error(...args);
		throw new TypeError(args.join(' '));
	} else {
		console.warn(...args);
	}
};

function lint (element: mixed, eventsToHandle: mixed): void {
	if (typeof eventsToHandle !== 'object') {
		report('`event` binding got invalid value:', eventsToHandle, 'for element', element);
		return;
	}

	_.each(eventsToHandle, (handler: mixed, event: string) => {
		if (typeof handler !== 'function') {
			report(
				event,
				'`event` binding got invalid event handler:',
				handler,
				'for element',
				element
			);
		}
	});
}

ko.bindingHandlers.event = _.defaults({
	init (element: mixed, valueAccessor: () => mixed, ...rest) {
		lint(element, valueAccessor() || {});
		return eventBindingHandlerBase.init(element, valueAccessor, ...rest);
	},
}, eventBindingHandlerBase);
